import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';
import { questionTypes } from './Filters/mocks';
import {
  getAssessments,
  tagsFromData,
  tagsWithAssessmentKeys,
  transformCategoryData,
} from './utils';
import { getCategories } from 'chameleon/src/components/TrendReportingContainer/client';
import { getTrendData } from './client';

import TrendReportTable from './Table';

import './Filters/style.scss';

const AssignmentTrendReport = (props) => {
  const { isStudent, educationPeriod } = props;
  const { assignmentId, subject, studentId } = props.params;

  const [data, setData] = useState([]);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedSchool, setSelectedSchool] = useState({});
  const [categories, setCategories] = useState([]);
  const transformedCategoryData = transformCategoryData(categories);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [parametersHaveChanged, setParametersHaveChanged] = useState(false);
  const [firstDate, setFirstDate] = useState('');
  const [lastDate, setLastDate] = useState('');
  const [assessmentData, setAssessmentData] = useState([]);
  const [questionTypeSelected, setQuestionTypeSelected] = useState(
    questionTypes[0],
  );
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    setSelectedClass(
      props.classes.items.find((item) =>
        item.recent.some((recent) => recent.id === assignmentId),
      ) || props.assignment.sectionId,
    );
    setSelectedSchool(
      props.me.me.schoolSet.find((item) => item.id === selectedClass.parentId),
    );
  }, []);

  useEffect(() => {
    if (!data) {
      setTags([]);
      setFirstDate('');
      setLastDate('');
      setAssessmentData([]);
      return;
    }
    const { assessments, firstDate, lastDate } = getAssessments(data);
    setFirstDate(firstDate);
    setLastDate(lastDate);
    setTags(tagsWithAssessmentKeys(tagsFromData(data)));
    setAssessmentData(assessments);
  }, [data]);

  useEffect(() => {
    getTrendDataForAssignment();
  }, [selectedClass, selectedCategory, questionTypeSelected]);

  useEffect(() => {
    if (parametersHaveChanged) {
      setParametersHaveChanged(false);
      setLoading(true);
      getTrendDataForAssignment();
    }
  }, [parametersHaveChanged]);

  const setupCategories = async () => {
    const categoryData = await getCategories(subject);
    setCategories(categoryData);
    const defaultSelectedCategory =
      transformCategoryData(categoryData).slice(-1)[0];
    setSelectedCategory(defaultSelectedCategory);
  };

  const getTrendDataForAssignment = () => {
    if (
      selectedClass &&
      selectedCategory &&
      selectedCategory.value &&
      questionTypeSelected
    ) {
      const queryDict = {
        tagCategoryId: selectedCategory.value,
        masterSubjectId: subject,
        educationPeriod,
        schoolId: selectedSchool.id,
        assignmentId,
        studentId,
        questionType: questionTypeSelected.label,
      };
      if (!isStudent) {
        queryDict.districtId = selectedSchool.parentId;
        queryDict.sections = [selectedClass.id];
      }
      getTrendData(queryDict).then((responseData) => {
        setData(responseData);
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    setupCategories();
  }, [educationPeriod]);

  return (
    <div>
      <div className="trend_report_filters_wrapper">
        <div className="trend_report_filter_group trend_report_filter_group_result">
          {categories.length > 0 && (
            <Fragment>
              <div>Course Component</div>
              <AutocompleteSelect
                options={transformedCategoryData}
                onChange={({ value: valueSelected }) => {
                  setParametersHaveChanged(true);
                  setSelectedCategory(
                    transformedCategoryData.find(
                      ({ value }) => valueSelected === value,
                    ),
                  );
                }}
                value={selectedCategory}
              />
            </Fragment>
          )}
          <AutocompleteSelect
            options={questionTypes}
            onChange={({ value: valueSelected }) => {
              setParametersHaveChanged(true);
              setQuestionTypeSelected(
                questionTypes.find(({ value }) => valueSelected === value),
              );
            }}
            value={questionTypeSelected}
          />
        </div>
      </div>
      <TrendReportTable
        checkedItems={{
          notAssessed: true,
          firstQuartile: true,
          secondQuartile: true,
          thirdQuartile: true,
          fourthQuartile: true,
        }}
        tags={tags}
        assessments={assessmentData}
        loading={loading}
        firstDateScored={firstDate}
        lastDateScored={lastDate}
        selectedCategoryLabel={selectedCategory?.label}
        hideAcessments={true}
        paramsData={{
          tagCategoryId: selectedCategory?.value,
          masterSubjectId: subject,
          educationPeriod,
          districtId: selectedSchool.parentId,
          schoolId: selectedSchool.id,
          sections: [selectedClass.id],
          dateFrom: firstDate.split(' ')[0],
          dateTo: lastDate.split(' ')[0],
          assignmentId,
          questionType: questionTypeSelected.label,
        }}
      />
    </div>
  );
};

AssignmentTrendReport.displayName = 'AssignmentTrendReport';

AssignmentTrendReport.propTypes = {
  assignment: PropTypes.object,
};

AssignmentTrendReport.defaultProps = {
  assignment: {},
};

export default AssignmentTrendReport;
